import { Component, OnInit, ViewChild } from '@angular/core';
import { TarifCodeService } from 'src/app/shared/services/tarif-code.service';

@Component({
  selector: 'app-tarifs',
  templateUrl: './tarifs.component.html',
  styleUrls: ['./tarifs.component.scss']
})
export class TarifsComponent implements OnInit {

  @ViewChild("dd", {static: false}) table;
	clonedType: { [s: number]: any; } = {};
	index: number;
	lastNewId: number = -1;
  public tarifs: any[] = [];

	constructor(private tarifCodeService: TarifCodeService) { }

  	ngOnInit() {
  		this.tarifCodeService.get().subscribe(t => this.tarifs = t);
  	}


    onRowEditInit(data: any, index: number) {
    	this.index = index;
       this.clonedType[data.id] = Object.assign({},{...data});
    }

    onRowEditCancel(data: any, index: number) {
        if (this.clonedType[data.id]) {
            this.tarifs[index] = this.clonedType[data.id];
            delete this.clonedType[data.id];
        } else {

        }
    }
  	onRowEditSave(data: any) {
  		this.tarifCodeService.save(data).subscribe(t => {
  			if (this.tarifs.findIndex(ts => ts.id === t.id ) >= 0) {
  				this.tarifs = this.tarifs.map(ts => (ts.id === t.id ? t : ts));
  			} else {
  				this.tarifs = this.tarifs.concat(t);
  			}
	  		delete this.clonedType[data.id];
  		});
  	}

  	addType() {

  		this.lastNewId--;
  		this.tarifs = this.tarifs.concat({
  			id: this.lastNewId,
  			name: '',
  		});
  		this.table.editingRowKeys[this.lastNewId] = true;

  	}
}
